export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/bwai_gif.693dcdaf.gif","height":620,"width":936,"blurWidth":0,"blurHeight":0};